import React from 'react';
import PropTypes from 'prop-types';
import { Link, Text } from 'components';
import generateRulesLink from 'utils/generateRulesLink';
import { MoreInfoLinkStyled } from './styles/MoreInfoLinkStyled';

const MoreInfoLink = ({ translate }) => (
  <MoreInfoLinkStyled>
    <Link href={generateRulesLink('account#profileSubscriptions')} referrerPolicy="unsafe-url">
      <Text type="uppercase" size="fs_xs" color="blue_doger" hover="blue_navyblue" font="din_bold">
        {translate('subscription_detailed')}
      </Text>
    </Link>
  </MoreInfoLinkStyled>
);

MoreInfoLink.propTypes = {
  translate: PropTypes.func.isRequired,
};

export default MoreInfoLink;
